package fr.manyverse.app.presentation.components.inventory

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.size
import androidx.compose.material3.Checkbox
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.ExposedDropdownMenuAnchorType
import androidx.compose.material3.ExposedDropdownMenuBox
import androidx.compose.material3.ExposedDropdownMenuDefaults
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import fr.manyverse.app.domain.model.ItemCategory
import manyverse.shared.generated.resources.Res
import manyverse.shared.generated.resources.inventory_category_all
import manyverse.shared.generated.resources.inventory_deselect_all
import manyverse.shared.generated.resources.inventory_filter_by_category
import manyverse.shared.generated.resources.inventory_select_all
import org.jetbrains.compose.resources.stringResource

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun InventoryCategoryFilterDropdown(
    selectedCategories: Set<ItemCategory>,
    onCategoriesChanged: (Set<ItemCategory>) -> Unit,
    modifier: Modifier = Modifier
) {
    var expanded by remember { mutableStateOf(false) }
    val allSelected = selectedCategories.size == ItemCategory.entries.size
    val labels = ItemCategory.entries.associateWith { it.label() }

    val summary = if (allSelected) {
        stringResource(Res.string.inventory_category_all)
    } else {
        ItemCategory.entries
            .filter { it in selectedCategories }
            .joinToString { labels.getValue(it) }
    }

    ExposedDropdownMenuBox(
        expanded = expanded,
        onExpandedChange = { expanded = !expanded },
        modifier = modifier
    ) {
        OutlinedTextField(
            value = summary,
            onValueChange = {},
            readOnly = true,
            label = { Text(stringResource(Res.string.inventory_filter_by_category)) },
            trailingIcon = {
                ExposedDropdownMenuDefaults.TrailingIcon(expanded = expanded)
            },
            colors = ExposedDropdownMenuDefaults.outlinedTextFieldColors(),
            modifier = Modifier
                .fillMaxWidth()
                .menuAnchor(ExposedDropdownMenuAnchorType.PrimaryEditable, true)
        )
        ExposedDropdownMenu(
            expanded = expanded,
            onDismissRequest = { expanded = false }
        ) {
            DropdownMenuItem(
                text = {
                    Text(
                        stringResource(
                            if (allSelected) Res.string.inventory_deselect_all
                            else Res.string.inventory_select_all
                        )
                    )
                },
                leadingIcon = { Checkbox(checked = allSelected, onCheckedChange = null) },
                onClick = {
                    onCategoriesChanged(
                        if (allSelected) emptySet() else ItemCategory.entries.toSet()
                    )
                }
            )
            HorizontalDivider()
            ItemCategory.entries.forEach { category ->
                val checked = category in selectedCategories
                DropdownMenuItem(
                    text = {
                        Row(
                            verticalAlignment = Alignment.CenterVertically,
                            horizontalArrangement = Arrangement.spacedBy(8.dp)
                        ) {
                            Icon(
                                painter = category.icon(),
                                contentDescription = null,
                                modifier = Modifier.size(20.dp)
                            )
                            Text(labels.getValue(category))
                        }
                    },
                    leadingIcon = { Checkbox(checked = checked, onCheckedChange = null) },
                    onClick = {
                        onCategoriesChanged(
                            if (checked) selectedCategories - category
                            else selectedCategories + category
                        )
                    }
                )
            }
        }
    }
}
